export default "__VITE_ASSET__CirkAgpk__"